





















































































import Vue, { PropType } from "vue";
import HttpClientFactory from "../../../services/HttpClientFactory";
import HttpClient from "../../../services/HttpClient";
import { TabPane, Tabs } from "../../../components";
import Receiver from "../../../types/receivers/Receiver";
import ReceiverAddress from "../../../types/receivers/ReceiverAddress";
import { DeliveryData } from "../../../types/receivers/deliveryTypes/DeliveryData";
import ApiReceiver from "../../../types/receivers/api/ApiReceiver";
import EditReceiverForm from "./pills/EditReceiverForm.vue";
import EditReceiverAddress from "./pills/EditReceiverAddress.vue";
import EditReceiverDelivery from "./pills/EditReceiverDelivery.vue";
import BaseAlert from "../../../components/black_dashboard_pro/BaseAlert.vue";
import { merge, snakeCase } from "lodash";
import { DefaultComputed, DefaultProps } from "vue/types/options";

type Methods = {
  markReceiverFormAsDirty(): void;
  markAddressFormAsDirty(): void;
  markDeliveryFormAsDirty(): void;
  updateGeneralData(receiver: Receiver): Promise<void>;
  updateReceiverAddress(address: ReceiverAddress): Promise<void>;
  updateReceiverDelivery(delivery: DeliveryData): Promise<void>;
  updateReceiver(receiver: Receiver): Promise<boolean>;
  showValidationError(field: string, rule: string): void;
  showGenericError(code: string, type: string): void;
  loadReceiver(): Promise<void>;
};

export default Vue.extend<any, Methods, DefaultComputed, DefaultProps>({
  props: {
    receiverId: {
      required: true,
      type: String as PropType<string>,
    },
  },
  components: {
    // @ts-ignore
    BaseAlert,
    TabPane,
    //@ts-ignore
    Tabs,
    EditReceiverForm,
    EditReceiverAddress,
    EditReceiverDelivery,
  },
  data() {
    return {
      isGeneralDataFormDirty: false,
      isAddressFormDirty: false,
      isDeliveryFormDirty: false,
      httpClient: {} as HttpClient,
      receiver: {
        address: {} as ReceiverAddress,
        companyName: "",
        contactEmail: "",
        contactName: "",
        contactPhone: "",
        deliveryData: {} as DeliveryData,
        deliveryType: "",
        id: 0,
        registrationNumber: "",
      } as Receiver,
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.loadReceiver();
  },
  methods: {
    markReceiverFormAsDirty(): void {
      this.isGeneralDataFormDirty = true;
    },
    markAddressFormAsDirty(): void {
      this.isAddressFormDirty = true;
    },
    markDeliveryFormAsDirty(): void {
      this.isDeliveryFormDirty = true;
    },
    async updateGeneralData(receiver: Receiver): Promise<void> {
      const mergedReceivers = Object.assign({ ...this.receiver, ...receiver });
      const result = await this.updateReceiver(mergedReceivers);
      if (result) {
        this.isGeneralDataFormDirty = false;
      }
    },
    async updateReceiverAddress(address: ReceiverAddress): Promise<void> {
      const mergedReceivers = Object.assign({
        ...this.receiver,
        address,
      });

      const result = await this.updateReceiver(mergedReceivers);

      if (result) {
        this.isAddressFormDirty = false;
      }
    },
    async updateReceiverDelivery(delivery: DeliveryData): Promise<void> {
      const mergedReceivers = Object.assign({
        ...this.receiver,
        ...delivery,
      });

      const result = await this.updateReceiver(mergedReceivers);

      if (result) {
        this.isDeliveryFormDirty = false;
      }
    },
    async updateReceiver(receiver: Receiver): Promise<boolean> {
      try {
        const response = await this.httpClient.put(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            `/receivers/v1/${this.receiver.id}`,
          receiver
        );

        this.receiver = response.data;

        const success: any = {
          text: this.$t("receiver:edit.message"),
          type: "success",
        };

        this.$notify(success);
        return true;
      } catch (e) {
        const errorCode: string = e.response.data.code;
        const arrayOfErrors: any[] = e.response.data.errors;
        if (arrayOfErrors !== undefined) {
          arrayOfErrors.forEach((error: any) => {
            this.showValidationError(
              snakeCase(error.field),
              snakeCase(error.rule)
            );
          });
          return false;
        }

        this.showGenericError(errorCode, "warn");
        return false;
      }
    },
    showValidationError(field: string, rule: string): void {
      const error: any = {
        text: this.$t("receiver:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
    showGenericError(code: string, type: string): void {
      const error: any = {
        text: this.$t(`receiver:${code}`),
        type,
      };
      this.$notify(error);
    },
    async loadReceiver(): Promise<void> {
      try {
        const response = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            `/receivers/v1/${this.receiverId}/view`
        );
        const receiverData: ApiReceiver = response.data;
        this.receiver = receiverData;
      } catch (e) {
        const error: any = {
          text: this.$t("receiver:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
  },
});
